






import { Component, Vue, Prop } from 'vue-property-decorator'
import VueMarkdown from 'vue-markdown'
// import 'github-markdown-css/github-markdown.css'
import 'static/css/github-markdown.css'
// import Highlight from 'vue-markdown-highlight/index.js'
// import hljs from 'highlight.js/lib/index.js'
// import 'highlight.js/styles/googlecode.css'
//
// Vue.directive('highlight', (el) => {
//   let blocks = el.querySelectorAll('pre code')
//   blocks.forEach((block) => {
//     hljs.highlightBlock(block)
//   })
// })

@Component({
  components: {
    VueMarkdown
    // Highlight,
    // hljs
  }
})
export default class MarkDown extends Vue {
    @Prop(String)
    content!: string
}
